import { INITIAL_STATE } from "../core"
import { SET_CURRENT_INVITE } from "../action_creators"

function currentInvite(state = INITIAL_STATE.currentInvite, action) {
    switch (action.type) {
        case SET_CURRENT_INVITE:
            return action.currentInvite
        default:
            return state
    }
}

export default currentInvite



// WEBPACK FOOTER //
// ./src/redux/reducers/current_invite_reducer.js